import React, { useState, useEffect } from 'react';
import './ApprovalSubmissions.css';

function ApprovalSubmissions({ apiBase, roleColor }) {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSubmissions();
  }, []);

  const loadSubmissions = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiBase}/contents?status_id=2&limit=50`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      if (data.ok && data.data) {
        setSubmissions(data.data.contents || []);
      }
    } catch (err) {
      console.error('Error loading submissions:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="approval-submissions">
      <h2>Status Pengajuan Approval</h2>
      {loading ? (
        <div className="loading"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="10" /></svg>Memuat...</div>
      ) : submissions.length === 0 ? (
        <div className="empty"><p>Tidak ada pengajuan pending</p></div>
      ) : (
        <div className="submissions-list">
          {submissions.map(item => (
            <div key={item.id} className="submission-item">
              <div><h4>{item.title}</h4><p>{item.slug}</p></div>
              <span className="badge badge-pending">Menunggu Approval</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ApprovalSubmissions;
